module.exports = __webpack_public_path__ + "static/img/1.a1fecd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutOur/1.jpg
// module id = 2wnC
// module chunks = 1